export default "__VITE_ASSET__cHG3Yz5C__"